// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__miH8n","close-button":"styles_close-button__QaorV","closeButton":"styles_close-button__QaorV"};